<template>
  <v-container fluid>
    <page-header @menuClick="chooseMenu" :menuItems="menuItems">
      Staff Schedules
    </page-header>

    <v-sheet height="600">
      <staff-schedule-list />
    </v-sheet>

    <v-dialog v-if="hasRoleManageSchedule" v-model="newScheduleDialog">
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn @click="newScheduleDialog = false" icon>
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <new-staff-schedule />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NewStaffSchedule from "@/components/schedule/NewStaffSchedule.vue";
import StaffScheduleList from "@/components/schedule/StaffScheduleList.vue";
const PageHeader = () => import("@/components/common/PageHeader.vue");

export default {
  components: { PageHeader, NewStaffSchedule, StaffScheduleList },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "currentUser"]),
    newScheduleDialog: {
        get(){
          return this.newSchedule && this.navState.dialog
        },
        set(newVal){
          return this.newSchedule = newVal;
        } 
    },
  },
  mounted() {
    this.hasRoleManageSchedule = this.currentUser.roles.includes("MANAGESCHEDULE");
    if(this.hasRoleManageSchedule){
      this.menuItems.push({
          id: "add-new-schedule",
          text: "New Staff Schedule",
          icon: "mdi-calendar-account-outline",
        })
    }
  },
  data() {
    return {
      newSchedule: false,
      menuItems: [],
      timestamp: Date.now(),
      hasRoleManageSchedule: false,
    };
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "showDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    chooseMenu(event, menuItem) {
      if (menuItem.id == "add-new-schedule") {
        this.newSchedule = true;
        this.showDialog();
      }
    },
  }
};
</script>

<style>
</style>